import { createAction, props } from '@ngrx/store';

export enum LanguageActionTypes {
  LanguagesSmsNotificationsSet = '[Languages] Sms Notifications Set',
}

export const actionLanguagesSmsNotificationsSet = createAction(
  LanguageActionTypes.LanguagesSmsNotificationsSet,
  props<{ code: string }>(),
);
